export default {
    'examineText': ['Not applied', 'Pending', 'Failed to pass', 'Passed'],
    'operation': 'Operation',
    'edit': 'Edit',
    'download': 'Click Download'
}
